export function normalizeTenantSlug(value: string): string {
  const slug = value.toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/^-+|-+$/g, "");
  if (!slug) throw new Error("Tenant slug is required");
  if (slug.length > 48) throw new Error("Tenant slug must be 48 characters or fewer");
  return slug;
}

export function tenantHostForSlug(slug: string, rootDomain = "haulbase.ai"): string {
  return `${normalizeTenantSlug(slug)}.${rootDomain}`;
}
